import AuthLayout from "./AuthLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import OTPInput from "react-otp-input";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../hooks/store";
import {
  useForgotPasswordMutation,
  usePostVerifyOtpMutation,
} from "../../services/auth";
import { OTP_ENUM } from "../../utils/enums";
import { showError, showToast } from "../../constants/toasts";
import Loader from "../../constants/Loader";
import { temporaryToken } from "../../reducers/authSlice";

const OtpVerification = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { state } = location;
  const navigate = useNavigate();
  const [otp, setOtp] = useState<string>("");

  const [countDown, setCountDown] = useState<number>(59);

  const [optVerificationMutation, { isLoading }] = usePostVerifyOtpMutation();
  const [ForgotPasswordMutation] = useForgotPasswordMutation();

  const handleSubmit = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    if (otp?.length != 4) {
      showError("Please enter one time password");
      return;
    }
    if (otp?.length === 4) {
      // setError(false);

      const body = {
        email: state?.email,
        code: otp,
        // otpType: OTP_ENUM.FORGOT_PASSWORD,
      };

      try {
        const response = await optVerificationMutation(body).unwrap();

        if (response?.statusCode === 200) {
          dispatch(temporaryToken({ tempToken: response?.data?.token }));
          showToast("OTP verified successfully");
          navigate("/reset-password", {
            replace: true,
            state: { ...state, otp },
          });
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (error: any) {
        if (error?.data?.message) {
          showError(error?.data?.message || "");
        }
      }
      // }
    }
  };

  const handleResendOtp = async () => {
    // e.preventDefault();
    const body = {
      email: state?.email,
      otpType: OTP_ENUM.FORGOT_PASSWORD,
    };
    try {
      const response = await ForgotPasswordMutation(body).unwrap();
      if (response?.statusCode === 200) {
        showToast("OTP Resent Successfully");
        setCountDown(59);
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (countDown > 0) {
      setTimeout(() => {
        setCountDown(countDown - 1);
      }, 1000);
    } else {
      setCountDown(0);
    }
  }, [countDown]);

  return (
    <AuthLayout>
      <Loader isLoad={isLoading} />
      <div className="authBox">
        <h2>OTP Verification</h2>
        <p>Please enter otp send to your email address</p>
        <form>
          <div className="control_group">
            <div className="opt_fields">
              <label>Enter OTP</label>
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={4}
                renderInput={(props) => <input {...props} />}
                inputType="tel"
              />
            </div>
            <div className="auth_bottom">
              <p>
                {countDown === 0 ? (
                  <span className="link" onClick={handleResendOtp}>
                    Resent OTP
                  </span>
                ) : (
                  <span>
                    {countDown < 10 ? (
                      <p>(00 : 0{countDown})</p>
                    ) : (
                      <p>(00 : {countDown})</p>
                    )}
                  </span>
                )}
              </p>
            </div>
          </div>
          <div className="form_btn">
            <Button className="btn btn_primary w_100" onClick={handleSubmit}>
              Submit
            </Button>
          </div>
        </form>
        <div className="auth_bottom">
          <p>
            <span className="link" onClick={() => navigate("/")}>
              <KeyboardBackspaceIcon /> Back to Login
            </span>
          </p>
        </div>
      </div>
    </AuthLayout>
  );
};

export default OtpVerification;
